import styled from 'styled-components';
import { Grid } from '../../layout';
import { breakpoint, theme } from '../../theme';
import { BodyText, UIText } from '../typography';

export const Wrapper = styled.footer`
  background-color: ${theme.colors.primary.graysGray};
  margin-top: auto;
  color: ${theme.colors.primary.white};
`;

export const Content = styled(Grid)`
  padding-top: ${theme.spacings[4].rem};
  padding-bottom: ${theme.spacings[5].rem};
  &&& {
    color: ${theme.colors.primary.white};
  }
`;

export const AppContainer = styled.div`
  ${breakpoint('md')`
      flex-direction: row;
      justify-content: space-between;
    `}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.neutrals.solidGrays[4]};
  padding-bottom: ${theme.spacings[4].rem};
  flex-wrap: wrap;
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacings[3].rem};
  margin-bottom: ${theme.spacings[4].rem};
  align-self: flex-start;
  ${breakpoint('md')`
      margin-bottom: 0px;
    `}
`;

export const AppLinks = styled.div`
  display: flex;
  align-self: flex-start;
  ${breakpoint('md')`
      align-self: center;
    `}
`;

export const AppInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[1].rem};
`;

export const AppTitle = styled.div`
  white-space: nowrap;
  ${theme.typography.body.sm}
  font-weight: bold;
  ${breakpoint('md')`
      ${theme.typography.body.md}
    `}
`;

export const AppSubtitle = styled.div`
  ${theme.typography.uiText.xs}
  ${breakpoint('md')`
      ${theme.typography.uiText.sm}
    `}
`;

export const SignupLinksContainer = styled.div`
  ${breakpoint('md')`
      display: grid;
      grid-template-columns: 4.8fr 1fr 1fr 1fr;
    `}
  display:flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid ${theme.colors.neutrals.solidGrays[4]};
`;

export const SignUpContainer = styled.div`
  margin-top: ${theme.spacings[5].rem};
  margin-bottom: ${theme.spacings[4].rem};
  max-width: 100%;
  ${breakpoint('md')`
      margin-bottom: ${theme.spacings[6].rem};
      width: 70%;
    `}
`;

export const WhiteText = styled(UIText).attrs({ size: 'xs' })`
  && {
    color: ${theme.colors.primary.white};
    margin-bottom: ${theme.spacings[2].rem};
    ${breakpoint('md')`
      ${theme.typography.uiText.sm};
      margin-bottom: ${theme.spacings[4].rem};
    `}
  }
`;

export const DisclaimerText = styled(BodyText).attrs({
  size: 'xs',
  color: `${theme.colors.primary.white}`,
})`
  font-size: 10px; //Todo- Change to XXS size
`;

export const FooterInfoContainer = styled.div`
  padding-top: ${theme.spacings[4].rem};
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  ${breakpoint('md')`
      flex-direction: row;
    `}
`;

export const IconsWrapper = styled.div`
  border-bottom: 1px solid ${theme.colors.neutrals.solidGrays[4]};
  margin-bottom: ${theme.spacings[6].rem};
  ${breakpoint('md')`
      border-bottom: none;
      margin-bottom: 0;
      display:flex;
      flex-direction:row;
      gap: ${theme.spacings[14].rem};
    `}
`;

export const LegalContainer = styled.div`
  max-width: 100%;
  ${breakpoint('md')`
      max-width: 40%;
    `}
`;

export const Title = styled(UIText).attrs({ size: 'md' })`
  && {
    ${breakpoint('md')`
      
    `}
    color: ${theme.colors.primary.white};
    margin-bottom: ${theme.spacings[4].rem};
    font-weight: bold;
  }
`;

export const SocialIcon = styled.a`
  margin-right: ${theme.spacings[2].rem};
`;

export const SocialContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  margin: ${theme.spacings[6].rem} 0;
  ${breakpoint('md')`
      text-align: left;
      margin-bottom: 0;
    `}
`;

export const PaymentContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  margin: ${theme.spacings[6].rem} 0;
  ${breakpoint('md')`
      text-align: left;
      margin-bottom: 0;
    `}
`;

export const PaymentIcon = styled.span`
  margin-right: ${theme.spacings[2].rem};
`;

export const CopyRightContainer = styled(BodyText).attrs({
  size: 'xs',
  color: `${theme.colors.primary.white}`,
})`
  && {
    margin-top: ${theme.spacings[3].rem};
  }
`;
